// import logo from './logo.svg';
// import './App.css';

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePage from "./Pages/home";
import AboutUsPage from "./Pages/about-us";
import ServicesMarketPage from "./Pages/services-market";
import FleetDetailsPage from "./Pages/fleet-details";
import ClientsPage from "./Pages/clients";
import GalleryPage from "./Pages/gallery";
import TestimonialsPage from "./Pages/testimonials";
import ContactPage from "./Pages/contact";
import ErrorElement from "./Pages/error-element";



const router = createBrowserRouter([
  {
    path: "*",
    element: <ErrorElement />,
  },
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/about-us",
    element: <AboutUsPage />,
  },
  {
    path: "/services-market",
    element: <ServicesMarketPage />,
  },
  {
    path: "/fleet-details",
    element: <FleetDetailsPage />,
  },
  {
    path: "/clients",
    element: <ClientsPage />,
  },
  {
    path: "/gallery",
    element: <GalleryPage />,
  },
  {
    path: "/testimonials",
    element: <TestimonialsPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  }
  

])
function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
